import { render, staticRenderFns } from "./EquipmentsPage.vue?vue&type=template&id=3a56c8ae&scoped=true"
import script from "./EquipmentsPage.vue?vue&type=script&lang=js"
export * from "./EquipmentsPage.vue?vue&type=script&lang=js"
import style0 from "./EquipmentsPage.vue?vue&type=style&index=0&id=3a56c8ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a56c8ae",
  null
  
)

export default component.exports